export default "__VITE_ASSET__DmVfUqh8__"